import { BarcodeButtonComponent } from './barcode-button.component';

export default angular
  .module('sfMobile.components.barcode-button', [
    'sfMobile.components.button-big',
    'sfMobile.services.barcode',
  ])
  .component('sfBarcodeButton', BarcodeButtonComponent).name;
